import { createBrowserRouter } from 'react-router-dom'

import { AdminDashboardPage } from '@/features/admin/pages/AdminDashboardPage'
import { AdminHiresPage } from '@/features/admin/pages/AdminHiresPage'
import { AdminOrganizationsPage } from '@/features/admin/pages/AdminOrganizationsPage'
import { AdminUsersPage } from '@/features/admin/pages/AdminUsersPage'
import { LmsSourcesPage } from '@/features/admin/pages/LmsSourcesPage'
import { ProgramsPage } from '@/features/admin/pages/ProgramsPage'
import { AccountSetupPage } from '@/features/auth/pages/AccountSetupPage'
import { ForgotPasswordPage } from '@/features/auth/pages/ForgotPasswordPage'
import { LoginPage } from '@/features/auth/pages/LoginPage'
import { RegisterRecruiterPage } from '@/features/auth/pages/RegisterRecruiterPage'
import { RegisterStudentPage } from '@/features/auth/pages/RegisterStudentPage'
import { ResetPasswordPage } from '@/features/auth/pages/ResetPasswordPage'
import { TwoFactorChallengePage } from '@/features/auth/pages/TwoFactorChallengePage'
import { TwoFactorSetupPage } from '@/features/auth/pages/TwoFactorSetupPage'
import { VerifyEmailPage } from '@/features/auth/pages/VerifyEmailPage'
import { ApplicationDetailPage } from '@/features/applications/pages/ApplicationDetailPage'
import { ApplicationHistoryPage } from '@/features/applications/pages/ApplicationHistoryPage'
import { JobDetailPage } from '@/features/jobs/pages/JobDetailPage'
import { JobsListPage } from '@/features/jobs/pages/JobsListPage'
import { NotificationsPage } from '@/features/notifications/pages/NotificationsPage'
import { AllCandidatesPage } from '@/features/recruiter/pages/AllCandidatesPage'
import { ApplicantsPage } from '@/features/recruiter/pages/ApplicantsPage'
import { CandidateSearchPage } from '@/features/recruiter/pages/CandidateSearchPage'
import { CandidateSearchV2Page } from '@/features/recruiter/pages/CandidateSearchV2Page'
import { HiredCandidatesPage } from '@/features/recruiter/pages/HiredCandidatesPage'
import { JobFormPage } from '@/features/recruiter/pages/JobFormPage'
import { MyTasksPage } from '@/features/recruiter/pages/MyTasksPage'
import { OrganizationProfilePage } from '@/features/recruiter/pages/OrganizationProfilePage'
import { RecruiterJobsListPage } from '@/features/recruiter/pages/RecruiterJobsListPage'
import { TeamManagementPage } from '@/features/recruiter/pages/TeamManagementPage'
import { ProfileWizardPage } from '@/features/student/pages/ProfileWizardPage'
import { StudentProfilePage } from '@/features/student/pages/StudentProfilePage'
import { AppShellLayout } from '@/layouts/AppShellLayout'
import { DashboardPage } from '@/pages/DashboardPage'
import { NotFoundPage } from '@/pages/NotFoundPage'
import { RoleGuard } from '@/routes/RoleGuard'
import { UserType } from '@/constants/roles'

export const router = createBrowserRouter([
  // Public — no session required.
  { path: '/login', element: <LoginPage /> },
  { path: '/register/student', element: <RegisterStudentPage /> },
  { path: '/register/recruiter', element: <RegisterRecruiterPage /> },
  { path: '/verify-email', element: <VerifyEmailPage /> },
  { path: '/forgot-password', element: <ForgotPasswordPage /> },
  { path: '/reset-password', element: <ResetPasswordPage /> },
  { path: '/account-setup', element: <AccountSetupPage /> },
  { path: '/two-factor/challenge', element: <TwoFactorChallengePage /> },

  // Authenticated.
  {
    element: <RoleGuard />,
    children: [
      {
        element: <AppShellLayout />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: 'security/two-factor', element: <TwoFactorSetupPage /> },
          { path: 'notifications', element: <NotificationsPage /> },

          {
            element: <RoleGuard allowedRoles={[UserType.Student]} />,
            children: [
              { path: 'profile', element: <StudentProfilePage /> },
              { path: 'profile/wizard', element: <ProfileWizardPage /> },
              { path: 'jobs', element: <JobsListPage /> },
              { path: 'jobs/:jobId', element: <JobDetailPage /> },
              { path: 'applications', element: <ApplicationHistoryPage /> },
              { path: 'applications/:id', element: <ApplicationDetailPage /> },
            ],
          },

          {
            element: <RoleGuard allowedRoles={[UserType.RecruiterUser, UserType.RecruiterAdmin]} />,
            children: [
              { path: 'recruiter/organization', element: <OrganizationProfilePage /> },
              { path: 'recruiter/jobs', element: <RecruiterJobsListPage /> },
              { path: 'recruiter/jobs/new', element: <JobFormPage /> },
              { path: 'recruiter/jobs/:jobId/edit', element: <JobFormPage /> },
              { path: 'recruiter/jobs/:jobId/applicants', element: <ApplicantsPage /> },
              { path: 'recruiter/candidates', element: <CandidateSearchPage /> },
              { path: 'recruiter/candidates-v2', element: <CandidateSearchV2Page /> },
              { path: 'recruiter/all-candidates', element: <AllCandidatesPage /> },
              { path: 'recruiter/tasks', element: <MyTasksPage /> },
              { path: 'recruiter/hires', element: <HiredCandidatesPage /> },
            ],
          },

          {
            element: <RoleGuard allowedRoles={[UserType.RecruiterAdmin]} />,
            children: [{ path: 'recruiter/team', element: <TeamManagementPage /> }],
          },

          {
            element: <RoleGuard allowedRoles={[UserType.SuperAdmin]} />,
            children: [
              { path: 'admin/dashboard', element: <AdminDashboardPage /> },
              { path: 'admin/users', element: <AdminUsersPage /> },
              { path: 'admin/organizations', element: <AdminOrganizationsPage /> },
              { path: 'admin/hires', element: <AdminHiresPage /> },
              { path: 'admin/lms-sources', element: <LmsSourcesPage /> },
              { path: 'admin/programs', element: <ProgramsPage /> },
            ],
          },
        ],
      },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
])
